import { ChainConfig } from "@silo/types";
import { satisfies } from "effect/Function";

export const local = satisfies<ChainConfig>()({ tokens: {} } as const);
